import type { LinkToContactSignature } from '@efdigital/ll-addon-content/types/components/parts/link-to-contact';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

const LinkToContact: TemplateOnlyComponent<LinkToContactSignature> = <template>
  <a href="#" ...attributes>Contact</a>
</template>;

export { LinkToContact };
